import { DISABLE_ALT_TIMES } from './';

export default function disableAltTimes() {
  return { type: DISABLE_ALT_TIMES };
}
